import React, { ReactElement } from 'react';
// import { validateDynamicTreatmentDetailsForm } from '../../../../modules/crm/inPatient/service/crmUtils';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormInputDate from '../FormInputDate/FormInputDate';
import FormInputNumber from '../FormInputNumber/FormInputNumber';
import { FormTextInput } from '../FormInputText/FormInputText';
import FormSelect from '../FormSelect/FormSelect';
const FormDynamic = (props: any): ReactElement => {
  const {inputType, key, label, required, isLoading, form, claimDetailBackup, regex, size = 12,
    noOfDecimalAllowed = 0, options = [], isFormDynamic} = useGetFormConfig(props);

  const getInputField = (): any => {
    switch (inputType) {
      case 'SINGLE_SELECT' :
        return(
          <FormSelect detail={{
            isLoading,
            form,
            claimDetailBackup,
            key,
            label,
            options,
            size,
            required,
            placeholder: 'Enter ' + label,
            isFormDynamic,
          }} />
        );
      case 'MULTI_SELECT' :
        return(
          <FormSelect detail={{
            isLoading,
            form,
            claimDetailBackup,
            key,
            label,
            options,
            mode: 'tags',
            size: size ? size : 12,
            required,
            placeholder: 'Enter ' + label,
            isFormDynamic,
          }} />
        );
      case 'NUMERIC_INPUT':
        return(
          <FormInputNumber detail={{
            isLoading,
            form,
            claimDetailBackup,
            key,
            label,
            size: size ? size : 12,
            required,
            noOfDecimalAllowed: noOfDecimalAllowed ? noOfDecimalAllowed : 0,
            // rules: [validateDynamicTreatmentDetailsForm(key)],
            regex,
            placeholder: 'Enter ' + label,
            isFormDynamic,
          }}/>
        );
      case 'TEXT_INPUT':
        return(
          <FormTextInput detail={{
            isLoading,
            form,
            claimDetailBackup,
            key,
            label,
            size: size ? size : 12,
            required,
            noOfDecimalAllowed: 0,
            // rules: [validateDynamicTreatmentDetailsForm(key)],
            regex,
            placeholder: 'Enter ' + label,
            isFormDynamic,
          }}
          />
        );
        case 'DATE_INPUT':
          return(
            <FormInputDate detail={{
              isLoading,
              form,
              claimDetailBackup,
              key,
              label,
              labelClass: 'mb-0',
              size: size ? size : 12,
              required,
              placeholder: 'Enter ' + label,
              isFormDynamic,
            }}
            />
          );
      default:
        return(
          <FormTextInput detail={{
            isLoading,
            form,
            claimDetailBackup,
            key,
            label,
            size: size ? size : 12,
            required,
            noOfDecimalAllowed: 0,
            // rules: [validateDynamicTreatmentDetailsForm(key)],
            regex,
            placeholder: 'Enter ' + label,
            isFormDynamic,
          }}
          />
        );
  }};

  return ( <React.Fragment>
      {getInputField()}
    </React.Fragment>
  );
};

export default FormDynamic;
